import * as types from './types';
import { setSpecialFlags } from '../../api/api';
import { apllicantData } from './applicantAction';

export const setDisblement = value => ({
  type: types.DISABLEMENT,
  payload: value
});

export const setRegistrationFop = value => ({
  type: types.STATE_REGISTARTION_2020,
  payload: value
});

export const setFlags = data => async dispatch => {
  try {
    await setSpecialFlags(data);
    dispatch(apllicantData(data.id));
  } catch (error) {
    console.log(error);
  }
};
